import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=4bd020d6&scoped=true&"
var script = {}
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=4bd020d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd020d6",
  null
  
)

export default component.exports